//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonMenu from "~/components/ButtonMenu";

export default {
	name: "parliamentarian-list-filter",
	components: {
		ButtonMenu,
	},
	props: {
		filters: {
			type: Object,
		},
	},
	computed: {
		searchModel: {
			get() {
				return this.$store.state.filters.parliamentarians.searchQuery;
			},
			set(value) {
				this.$store.commit("filters/SET_SEARCH_QUERY", {
					view: "parliamentarians",
					res: value,
				});
			},
		},
	},
	data() {
		return { filterToggled: false };
	},
	methods: {
		toggleFilter() {
			this.filterToggled = !this.filterToggled;
		},
		filterParty(element) {
			this.$store.commit("filters/TOGGLE_FILTER", {
				view: "parliamentarians",
				type: "party",
				element: element.id,
			});
		},
		filterFaction(element) {
			this.$store.commit("filters/TOGGLE_FILTER", {
				view: "parliamentarians",
				type: "faction",
				element: element.id,
			});
		},
		filterCanton(element) {
			this.$store.commit("filters/TOGGLE_FILTER", {
				view: "parliamentarians",
				type: "canton",
				element: element,
			});
		},
		orderByDesc(direction) {
			this.$store.commit("SET_PARLIAMENTARIANS_ORDER_BY_DESC", direction);
		},
		toggleView() {
			this.$store.commit("TOGGLE_PARLIAMENTARIAN_GRID_VIEW");
		},
	},
};
